import Client from "../client";

class BackupRepository  {
    private client: Client;
    constructor(client: Client) {
        this.client = client;
    }
    getConfiguration() {
        return this.client.get(this.client.getRootDocument().Links["BackupConfiguration"]);
    }
    updateConfiguration(configuration: any) {
        return this.client.update(configuration.Links["Self"], configuration);
    }
}

export default BackupRepository;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/repositories/backupRepository.ts